import React, { useState, useEffect } from "react";

import { getHandHygieneRecords } from "../../../service/endpoint-manager";

import HandHygieneRecords from "./HandHygieneRecords";
import CompliancePercentageTable from "./CompliancePercentageTable";

import HHDataFiltersComponent from "../HHDataFiltersComponent";

import {
  getCurrentDate,
  getFirstDayOfMonth,
  getUniqueUserIds,
} from "@thequantumhub/iam-package";

const HHDashboard = () => {
  const [units, setUnits] = useState([]);

  const [selectedUnit, setSelectedUnit] = useState("");
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [recordStatus, setRecordStatus] = useState("Active");
  const [selectedHealthcareWorker, setSelectedHealthcareWorker] =
    useState("All");
  const [selectedMoment, setSelectedMoment] = useState("All");
  const [selectedOutcome, setSelectedOutcome] = useState("All");
  const [selectedUser, setSelectedUser] = useState("All");
  const [startDate, setStartDate] = useState(getFirstDayOfMonth());
  const [endDate, setEndDate] = useState(getCurrentDate());

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getHandHygieneRecords({ deleted: false });

        if (
          response &&
          response.data &&
          response.data.body &&
          Array.isArray(response.data.body)
        ) {
          setRecords(response.data.body);
        } else {
          setError("Data format is incorrect or no records found");
        }
      } catch (error) {
        console.error("Fetch error:", error);
        setError("Failed to fetch records");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Filter logic
  useEffect(() => {
    loadData();
  }, [
    startDate,
    endDate,
    selectedUnit,
    recordStatus,
    selectedHealthcareWorker,
    selectedMoment,
    selectedOutcome,
    selectedUser,
  ]);

  const loadData = async () => {
    try {
      var tempStartDate = new Date(startDate);
      var tempendDate = new Date(endDate);
      const response = await getHandHygieneRecords({
        deleted: recordStatus === "Deleted",
        from: tempStartDate.toISOString(),
        to: tempendDate.toISOString(),
      });
      let records = response.data.body;

      if (selectedUnit && selectedUnit !== "all") {
        records = records.filter((record) => record.unit === selectedUnit);
      }
      if (selectedHealthcareWorker !== "All") {
        records = records.filter(
          (record) =>
            record.formQuestions.healthCareWorker === selectedHealthcareWorker
        );
      }
      if (selectedMoment !== "All") {
        records = records.filter(
          (record) => record.formQuestions.handHygieneMoment === selectedMoment
        );
      }

      if (selectedOutcome !== "All") {
        records = records.filter(
          (record) => record.formQuestions.outcome === selectedOutcome
        );
      }
      if (selectedUser && selectedUser !== "All") {
        records = records.filter((record) => record.createdBy === selectedUser);
      }

      setRecords(records);
    } catch (error) {
      console.error("Error fetching PPE records:", error);
    }
  };

  const resetFilters = () => {
    setUnits([]);
    setSelectedUnit("");
    setRecordStatus("Active");
    setSelectedHealthcareWorker("All");
    setSelectedUser("All");
    setStartDate("");
    setEndDate("");
  };
  return (
    <div>
      <HHDataFiltersComponent
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        selectedUnit={selectedUnit}
        setSelectedUnit={setSelectedUnit}
        units={units}
        setUnits={setUnits}
        recordStatus={recordStatus}
        setRecordStatus={setRecordStatus}
        selectedHealthcareWorker={selectedHealthcareWorker}
        setSelectedHealthcareWorker={setSelectedHealthcareWorker}
        selectedMoment={selectedMoment}
        setSelectedMoment={setSelectedMoment}
        selectedOutcome={selectedOutcome}
        setSelectedOutcome={setSelectedOutcome}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        resetFilters={resetFilters}
      />
      <CompliancePercentageTable records={records} />
      <HandHygieneRecords
        records={records}
        loading={loading}
        error={error}
        setRecords={setRecords}
      />
    </div>
  );
};

export default HHDashboard;
